<div class="form-group" *ngIf="!forTimeslot && !forAmendFlight && !forFlyback">

  <mat-form-field appearance="outline" class="full-width">

    <input matInput name="customDate" id="customDate" #customDate="ngModel" [(ngModel)]="dateInput"
      [matDatepicker]="picker" [matDatepickerFilter]="dateFilter" [min]="minDateObj" [max]="maxDateObj"
      (dateChange)="dateChanged($event.value)" required>

    <mat-label>{{ labelText }}</mat-label>

    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>

    <mat-datepicker #picker [startAt]="dateInput" (opened)="onPickerOpened()" (closed)="onPickerClosed()"></mat-datepicker>

    <mat-error *ngIf="customDate.invalid && customDate.dirty">
      {{ dateError }}
    </mat-error>

  </mat-form-field>

</div>

<ng-container *ngIf="forAmendFlight">
  <!-- Hidden input: required for Material -->
  <input matInput #pickerAnchor [matDatepicker]="pickerAmend" [matDatepickerFilter]="dateFilter" [(ngModel)]="dateInput"
    [min]="minDateObj" [max]="maxDateObj" (dateInput)="dateChanged($event)">

  <!-- Custom trigger -->
  <span class="placeholder" (click)="pickerAmend.open()">
    <ng-content></ng-content>
  </span>

  <mat-datepicker #pickerAmend [startAt]="dateInput" (opened)="onPickerOpened()" (closed)="onPickerClosed()"></mat-datepicker>
</ng-container>

<div *ngIf="forTimeslot">

  <!-- Hidden Material anchor input (required by mat-datepicker) -->
  <input matInput [matDatepicker]="pickerTimeslot" [(ngModel)]="dateInput" [matDatepickerFilter]="dateFilter"
    [min]="minDateObj" [max]="maxDateObj" (dateInput)="dateChanged($event.value)"
    style="position:absolute; opacity:0; width:0; height:0; pointer-events:none;">

  <mat-datepicker #pickerTimeslot [startAt]="dateInput" (opened)="onPickerOpened()" (closed)="onPickerClosed()"></mat-datepicker>

  <!-- Radio is only for selection UI -->
  <input type="radio" name="date" id="dateCalendar" [checked]="!!selectedDate" required>

  <!-- Clickable trigger -->
  <label class="flex" for="dateCalendar" (click)="pickerTimeslot.open()" (keyup.enter)="pickerTimeslot.open()">

    <ng-container *ngIf="!selectedDate">
      <i class="icon">calendar</i>
      <p class="label__date">{{ labelText }}</p>
    </ng-container>

    <p class="radio--calendar__display" *ngIf="selectedDate">
      <span>{{ selectedDate | amDateFormat:'ddd' }}</span>
      <span>{{ selectedDate | amDateFormat:'D' }}</span>
      <span>{{ selectedDate | amDateFormat:'MMM' }}</span>
    </p>

  </label>

</div>

<div *ngIf="forFlyback" class="form-group flyback-datepicker-wrapper" (click)="pickerFlyback.open()">

  <!-- Hidden Material anchor input -->
  <input matInput [matDatepicker]="pickerFlyback" [matDatepickerFilter]="dateFilter"
    [(ngModel)]="dateInput" [min]="minDateObj" [max]="maxDateObj"
    (dateInput)="dateChanged($event.value)"
    style="position:absolute; opacity:0; width:0; height:0; pointer-events:none;">

  <mat-datepicker #pickerFlyback [startAt]="dateInput" (opened)="onPickerOpened()" (closed)="onPickerClosed()"></mat-datepicker>

  <!-- Visible readonly input -->
  <div class="flyback-datepicker-field">
    <label class="flyback-datepicker-label">{{ labelText || 'dd/mm/yyyy' }}</label>
    <div class="flyback-datepicker-row">
      <input class="flyback-datepicker-input"
        type="text"
        readonly
        [value]="dateInput ? (dateInput | date:'dd/MM/yyyy') : ''">
      <span class="flyback-datepicker-icon">
        <i class="icon">calendar</i>
      </span>
    </div>
  </div>

</div>
